import { render, staticRenderFns } from "./YearsComponent.vue?vue&type=template&id=a5f56232&scoped=true&"
import script from "./YearsComponent.vue?vue&type=script&lang=js&"
export * from "./YearsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f56232",
  null
  
)

export default component.exports